import { motion } from "framer-motion";
import { WHYNOW } from "@/constants/testIds";

export default function WhyNow() {
  return (
    <section
      id="whynow"
      data-testid={WHYNOW.root}
      className="relative bg-[#ffffff] border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.3em] text-black/65">
              <span className="eyebrow-bar" aria-hidden="true" />
              <span>Why Now</span>
            </div>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tightest max-w-4xl text-[#0a0a0a]">
              Amplify your staff with AI.
              <span className="block italic font-light text-black/65">
                Don't shrink behind it.
              </span>
            </h2>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 md:mt-12 max-w-3xl space-y-6"
            >
              <p className="font-serif text-2xl md:text-3xl leading-[1.35] tracking-tight text-[#0a0a0a]">
                AI just put your most ambitious plans within reach. The easy move is
                to use it to <span className="italic">cut</span> —{" "}
                <strong className="font-semibold">fewer people, a leaner budget, a
                smaller company.</strong>
              </p>
              <p className="font-serif text-2xl md:text-3xl leading-[1.35] tracking-tight text-[#0a0a0a]">
                The move that pays is the opposite:{" "}
                <strong className="font-semibold">keep your people</strong>, give them
                the right tools, and{" "}
                <strong className="font-semibold">hire more behind them</strong>. Each
                one now reaches further than before.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
